import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import API from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

import { PROCESS_TYPE } from '../constants/constants';

const buildUpdateSendoutDetailsAlert = ({ severity, body }) => ({
  severity,
  title: strings.formatString(strings.sendoutsV2.alerts.submitMessages[severity].title, {
    processType: PROCESS_TYPE.Sendout.title,
    action: severity === 'success' ? 'Updated' : 'Updating'
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const updateSendoutDetails = async ({ sendoutId, payload }) => {
  try {
    const response = await API.patch(`${Endpoints.Sendouts}/${sendoutId}`, payload);

    if (response.status !== HTTPStatusCodes.Ok) {
      return {
        success: false,
        response,
        alert: buildUpdateSendoutDetailsAlert({
          severity: 'error',
          body: `Unexpected response status: ${response.status}`
        })
      };
    }

    return {
      success: true,
      response,
      alert: buildUpdateSendoutDetailsAlert({
        severity: 'success'
      })
    };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildUpdateSendoutDetailsAlert({
        severity: 'error',
        body: getErrorMessage(error, error?.message ?? strings.shared.ui.unknownError.title)
      })
    };
  }
};
